/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiagLab } from 'app/shared/model/diag-lab.model';

export interface IDiagLabPanel {
  id?: string;
  active?: boolean;
  description?: string;
  displayKey?: string | null;
  lastUpdated?: number | null;
  name?: string;
  sample?: string | null;
  sortOrder?: number | null;
  timestampEntry?: number;
  microSec?: number;
  cursor?: number;
  diagLab?: IDiagLab | null;
}

export const defaultValue: Readonly<IDiagLabPanel> = {
  active: false,
};
